import { render, staticRenderFns } from "./versionRecord.vue?vue&type=template&id=1d533bae&scoped=true&"
import script from "./versionRecord.vue?vue&type=script&lang=js&"
export * from "./versionRecord.vue?vue&type=script&lang=js&"
import style0 from "./versionRecord.vue?vue&type=style&index=0&id=1d533bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d533bae",
  null
  
)

export default component.exports